import React, { useState, useCallback, useEffect } from 'react';
import Calendar from './CalendarRice';
import MappingCalendarRice from './MappingCalendarRice';
import {getYear} from "date-fns";
import axios from "axios"

function CalendarParentRice() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [locations, setLocations] = useState([]);
    const [fetchKey, setFetchKey] = useState(0);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        // 좁은 화면 여부 상관없이 항상 YYYY-MM-DD 형식으로 출력
        return `${year}-${month}-${day}`;
    };

    const start = startDate ? formatDate(startDate) : '';
    const end = endDate ? formatDate(endDate) : '';

    // 여기서 fetchLocationData를 정의하고 호출
    const fetchLocationData = useCallback(() => {
        const baseURL = 'https://disease.scnu.ac.kr/riceblastlocation/';
        const url = (start && end) ? `${baseURL}?start=${start}&end=${end}` : baseURL;

        axios.get(url)
            .then(res => {
                const filteredData = res.data.filter(location => location.status === 1);
                setLocations(filteredData);
            })
            .catch(err => {
                console.error('위치 데이터를 가져오는 데 실패했습니다: ', err);
            });
    }, [start, end]);

    // 날짜가 변경될 때마다 데이터를 가져옴
    useEffect(() => {
        fetchLocationData();
    }, [fetchLocationData]);

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };

    const applyDates = () => {
        setFetchKey(prevKey => prevKey + 1);
    };

    const today = new Date();
    const currentYear = formatDate(today);

    return (
        <div style={{ position: "relative", zIndex: "3", display: "flex", flexDirection: "column" }}>
            <div
                className="grid gap-6 grid-cols-1 md:grid-cols-2 mb-6"
                style={{ position: "relative", zIndex: "3", marginLeft: "10%", marginRight: "10%" }}
            >
                {/* 시작 날짜 부분 */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", alignItems: "center", gap: "10px" }}>
                    <div>시작 날짜</div>
                    <Calendar onDateSelect={handleStartDateChange} />
                </div>

                {/* 끝 날짜 부분 */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", alignItems: "center", gap: "10px" }}>
                    <div>끝 날짜</div>
                    <Calendar onDateSelect={handleEndDateChange} />
                </div>
            </div>

            <div style={{ display: "flex", marginLeft: "10%" }}>시작 날짜: {startDate ? formatDate(startDate) : "1990-02-26"}</div>
            <div style={{ display: "flex", marginLeft: "10%" }}>끝 날짜: {endDate ? formatDate(endDate) : currentYear}</div>

            {/* 여기서 locations를 Mapping에 props로 전달 */}
            <MappingCalendarRice startDate={startDate} endDate={endDate} locations={locations} />
        </div>
    );
}

export default CalendarParentRice;
